import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  Card,
  Spinner
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getSurveyById } from 'services/surveys';
import SurveyShareManager from 'components/app/surveys/components/SurveyShareManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShare, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const SurveyShares = () => {
  const [searchParams] = useSearchParams();
  const surveyId = searchParams.get('id');
  const [survey, setSurvey] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!surveyId) {
      toast.error('No se especificó el ID de la encuesta.', {
        theme: 'colored'
      });
      setLoading(false);
      return;
    }

    // Cargar los datos de la encuesta
    getSurveyById(surveyId)
      .then(response => {
        if (response.result) {
          setSurvey(response.survey);
        } else {
          toast.error('No se encontró la encuesta.', { theme: 'colored' });
        }
      })
      .catch(error => {
        console.error('Error al cargar la encuesta:', error);
        toast.error('Error al cargar los datos de la encuesta.', {
          theme: 'colored'
        });
      })
      .finally(() => setLoading(false));
  }, [surveyId]);

  if (loading) {
    return (
      <Container fluid className="py-3">
        <div className="text-center py-5">
          <Spinner animation="border" role="status" className="me-2" />
          <span>Cargando datos de la encuesta...</span>
        </div>
      </Container>
    );
  }

  if (!survey) {
    return (
      <Container fluid className="py-3">
        <Card>
          <Card.Body className="text-center py-5">
            <h5 className="text-muted">Encuesta no encontrada</h5>
            <p className="text-muted">
              No se pudo cargar la información de la encuesta solicitada.
            </p>
            <Link to="/surveys" className="btn btn-primary">
              <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
              Volver a Encuestas
            </Link>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return (
    <Container fluid className="py-3">
      {/* Breadcrumb */}
      <Row className="mb-3">
        <Col>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/surveys' }}>
              Encuestas
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <FontAwesomeIcon icon={faShare} className="me-2" />
              Reportes Compartidos
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>

      {/* Header */}
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Header className="bg-primary text-white">
              <Row className="align-items-center">
                <Col>
                  <h4 className="mb-0">
                    <FontAwesomeIcon icon={faShare} className="me-3" />
                    Gestión de Reportes Compartidos
                  </h4>
                  <p className="mb-0 mt-2 opacity-75">
                    Administra cómo se comparten los reportes de la encuesta:{' '}
                    <strong>{survey.name}</strong>
                  </p>
                </Col>
                <Col xs="auto">
                  <Link
                    to={`/surveys/edit?id=${survey.id}`}
                    className="btn btn-outline-light btn-sm"
                  >
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                    Volver a Editar Encuesta
                  </Link>
                </Col>
              </Row>
            </Card.Header>
          </Card>
        </Col>
      </Row>

      {/* Información de la encuesta */}
      <Row className="mb-3">
        <Col>
          <Card>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <div className="mb-2">
                    <strong>Encuesta:</strong> {survey.name}
                  </div>
                  {survey.description && (
                    <div className="mb-2">
                      <strong>Descripción:</strong> {survey.description}
                    </div>
                  )}
                </Col>
                <Col md={6}>
                  <div className="mb-2">
                    <strong>Estado:</strong>{' '}
                    <span
                      className={`badge ${
                        survey.is_active ? 'bg-success' : 'bg-secondary'
                      }`}
                    >
                      {survey.is_active ? 'Activa' : 'Inactiva'}
                    </span>
                  </div>
                  <div className="mb-2">
                    <strong>Token:</strong> <code>{survey.survey_token}</code>
                  </div>
                  <div>
                    <strong>Creada:</strong> {survey.created_at}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Componente de gestión de shares */}
      <Row>
        <Col>
          <SurveyShareManager surveyId={survey.id} surveyName={survey.name} />
        </Col>
      </Row>
    </Container>
  );
};

export default SurveyShares;
